import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type Layout_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', appearance: { __typename?: 'AssetAggregateAppearance', layout: Types.AssetAggregateLayoutEnum } };

export type Layout_Collection_Fragment = { __typename?: 'Collection', appearance: { __typename?: 'AssetAggregateAppearance', layout: Types.AssetAggregateLayoutEnum } };

export type Layout_CollectionShare_Fragment = { __typename?: 'CollectionShare', appearance: { __typename?: 'AssetAggregateAppearance', layout: Types.AssetAggregateLayoutEnum } };

export type LayoutFragment = Layout_AdHocAssetsShare_Fragment | Layout_Collection_Fragment | Layout_CollectionShare_Fragment;

export const Layout = /*#__PURE__*/ gql`
    fragment Layout on AssetAggregate {
  appearance {
    layout
  }
}
    ` as unknown as DocumentNode<LayoutFragment, unknown>;

        

        
export const useLayoutFragment = (
  input: string | Omit<UseFragmentOptions<LayoutFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetAggregate' } };
    return input;
  })();

  return useFragment<LayoutFragment>({
    fragment: Layout,
    fragmentName: 'Layout',
    ...options,
  });
};
  
        